<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <PageHeader :title="title" :items="items"/>
        <b-card>
          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="district_id">District</label>
                <select v-model="search_data.district_id" @change="getMouza(search_data.district_id)"
                        class="form-control form-control-sm" name="district_id" id="district_id">
                  <option selected :value="''">Select a District</option>
                  <option v-for="(district, index) in districts" :key="index" :value="district.id">{{ district.id }} :
                    {{ district.district_desc }}
                  </option>
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="mouza_id">Mouza</label>
                <select v-model="search_data.mouza_id" @change="getPlot(search_data.mouza_id)"
                        class="form-control form-control-sm" name="mouza_id" id="mouza_id">
                  <option selected :value="''">Select a Mouza</option>
                  <option v-for="(mouza, index) in mouzas" :key="index" :value="mouza.id">{{ mouza.id }} :
                    {{ mouza.mouza_desc }}
                  </option>
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="plot_schedule_id">Plot No</label>
                <select v-model="search_data.plot_schedule_id" v-validate="'required'"
                        class="form-control form-control-sm" name="plot_schedule_id" id="plot_schedule_id">
                  <option selected :value="''">Select a plot</option>
                  <option v-for="(plot, index) in plots" v-bind:value="plot.id" :key="index">{{ plot.plot_no }}</option>
                </select>
              </div>
            </div>
            <button class="btn btn-success btn-sm mt-2" @click.prevent="search">Search</button>
          </form>
        </b-card>

        <b-card>
          <div class="mb-1" v-if="jvr_lists.total > 0">
            <download-excel
                class="btn btn-success float-right mb-1"
                :fetch="fetchData"
                :fields="jvr_fields"
                :meta="json_meta"
                :before-generate="startDownload"
                :before-finish="finishDownload"
                worksheet="jvr"
                name="jvr.xls">
              Download Excel
            </download-excel>
          </div>

          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped" id="titledExcel">
              <thead>
              <tr>
                <th>Sl</th>
                <th>Mouza</th>
                <th>Plot</th>
                <th>Name</th>
                <th>Father Name</th>
                <th>Shang</th>
                <th>Address</th>
                <th>Land Ownership By</th>
                <th>Land Type</th>
                <th>Aquired Land</th>
                <th>Remarks</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(jvr_list, index) in jvr_lists.data" :key="index">
                <td>{{ jvr_lists.from + index }}</td>
                <td>{{ jvr_list.mouza ? jvr_list.mouza.mouza_desc : '' }}</td>
                <td>{{ jvr_list.plot ? jvr_list.plot.plot_no : '' }}</td>
                <td>{{ jvr_list.name }}</td>
                <td>{{ jvr_list.father_name }}</td>
                <td>{{ jvr_list.shang }}</td>
                <td>{{ jvr_list.address }}</td>
                <td>{{ jvr_list.owner ? jvr_list.owner.land_ownership_by_desc : '' }}</td>
                <td>{{ jvr_list.land ? jvr_list.land.land_type_desc : '' }}</td>
                <td>{{ jvr_list.aquired_land }}</td>
                <td>{{ jvr_list.remarks }}</td>
                <td>
                  <a href="javascript:void(0);"
                     class="action-icon" title="View JVR" @click="viewJvr(jvr_list)">
                    <i class="mdi mdi-account-card-details viewColor"></i>
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
            <div v-if="loader" class="loader">Loading...</div>
            <h5 class="text-center text-secondary" v-if="jvr_lists.total === 0 || !flag">
              No Data Found
            </h5>
            <div class="float-right mt-1">
              <pagination :data="jvr_lists" :limit="2" @pagination-change-page="getResults"></pagination>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <view-modal
        :jvr_list="jvr_list"
    ></view-modal>
  </Layout>
</template>
<script>
import appConfig from "@src/app.config.json";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import XLSX from 'xlsx';
import viewModal from './modal/viewModal'

export default {
  page: {
    title: "List of JVR Lands",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader, viewModal},
  data() {
    return {
      title: "List of JVR Lands",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "List of JVR Lands",
          active: true
        }
      ],
      search_data: {
        mouza_id: '',
        plot_schedule_id: '',
        district_id: '',
      },
      plots: [],
      districts: [],
      all_upazilas: [],
      all_unions: [],
      mouzas: [],
      land_types: [],
      jvr_lists: {},
      flag: false,
      loader: false,
      jvr_list: {},
      jvr_fields: {
        'Mouza': 'mouza.mouza_desc',
        'Plot': 'plot.plot_no',
        'Name': 'name',
        'Father Name': 'father_name',
        'Shang': 'shang',
        'Address': 'address',
        'Land Ownership By': 'owner.land_ownership_by_desc',
        'Land Type': 'land.land_type_desc',
        'Aquired Land': 'aquired_land',
        'Remarks': 'remarks',
      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
    };
  },

  mounted() {
    this.getCodes();
  },
  methods: {
    getCodes() {
      http.get("api/jvr/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.land_types = data.land_types;
          this.districts = data.districts;
          this.mouzas = data.mouzas;
        }
      });
    },
    search() {
      this.flag = true
      this.loader = true
      http.post("api/jvr/view/search", this.search_data).then(response => {
        if (!response.error) {
          this.flag = true;
          this.loader = false
          this.jvr_lists = response.data.jvr_lists;

        }
      });
    },
    getResults(page = 1) {
      this.flag = true
      this.loader = true
      http.post('api/jvr/view/search?page=' + page, this.search_data)
          .then(response => {
            this.flag = true;
            this.loader = false
            this.jvr_lists = response.data.jvr_lists;
          });
    },
    onexport(evt) {
      var tbl = document.getElementById('titledExcel');
      var wb = XLSX.utils.table_to_book(tbl);
      XLSX.writeFile(wb, "jvr.xlsx");
    },
    viewJvr(jvr_list) {
      this.jvr_list = {};
      this.jvr_list = jvr_list;
      this.$root.$emit("bv::show::modal", "jvr-view-page-modal");
    },
    getPlot(mouza_id) {
      this.plots = [];
      this.search_data.plot_schedule_id = '';
      if (mouza_id === '' || mouza_id === null) {
        this.plots = [];
      } else {
        http.get("api/jvr/getPlot/" + mouza_id).then(response => {
          if (!response.error) {
            let data = response.data;
            this.plots = data.plots;
          }
        });
      }
    },
    getMouza(district_id) {
      this.mouzas = []
      this.search_data.mouza_id = '';
      if (district_id === '' || district_id === null) {
        this.mouzas = [];
      } else {
        http.get("api/jvr/getMouza/" + district_id).then(response => {
          if (!response.error) {
            let data = response.data;
            this.mouzas = data.mouzas;
          }
        });
      }
    },
    async fetchData() {
      const response = await http.post("api/jvr/view/download", this.search_data);
      return response.data.jvr_lists;
    },
    startDownload() {
      alert('It will take some time, Loading...');
    },
    finishDownload() {
      alert('Download completed.');
    },
  },
  computed: {
    userPermission() {
      return this.$store.state.user
    },
  },
  created() {
    this.$store.dispatch('getUserPermission')
  },
};
</script>
<style src="vue-select/dist/vue-select.css"></style>
